var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3147 3.57741C12.7448 2.54125 11.256 2.54125 10.6861 3.57741L2.22297 18.9648C1.67315 19.9645 2.39639 21.1877 3.53729 21.1877H20.4635C21.6044 21.1877 22.3276 19.9645 21.7778 18.9648L13.3147 3.57741ZM12.3506 4.32194C12.1984 4.0464 11.8024 4.0464 11.6502 4.32194L3.328 19.3944C3.1808 19.661 3.37364 19.9877 3.67817 19.9877H20.3226C20.6271 19.9877 20.82 19.661 20.6728 19.3944L12.3506 4.32194Z",
    fill: "#FAD682"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2504 17.5V17C11.2504 16.5858 11.5862 16.25 12.0004 16.25C12.4146 16.25 12.7504 16.5858 12.7504 17V17.5C12.7504 17.9142 12.4146 18.25 12.0004 18.25C11.5862 18.25 11.2504 17.9142 11.2504 17.5Z",
    fill: "#FAD682"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2504 14.5V9.00002C11.2504 8.58581 11.5862 8.25002 12.0004 8.25002C12.4146 8.25002 12.7504 8.58581 12.7504 9.00002V14.5C12.7504 14.9142 12.4146 15.25 12.0004 15.25C11.5862 15.25 11.2504 14.9142 11.2504 14.5Z",
    fill: "#FAD682"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.a5d515de.svg";
export { ForwardRef as ReactComponent };